import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoNaq: CultureInfo = {
  name: 'naq',
  displayName: 'Khoekhoegowab',
  iso3LanguageCode: 'naq',
  iso2LanguageCode: 'naq',
  ietfLanguageTag: 'naq',
  parent: null
};
